module.exports = __webpack_public_path__ + "static/media/apple-touch-icon-180x180.ba59fdbd.png";